// extracted by mini-css-extract-plugin
export var animationContainer = "_ps-0";
export var footer = "_ps-1";
export var gray = "_ps-2";
export var lineItem = "_ps-3";
export var lineItemImage = "_ps-4";
export var lineItemInfo = "_ps-5";
export var lineItemText = "_ps-6";
export var lineItems = "_ps-7";
export var modalContent = "_ps-8";
export var options = "_ps-9";
export var orderName = "_ps-a";
export var refundAmount = "_ps-b";